// Lib
import React from 'react';

// Components
import SheetContainer, {
    CloseButton,
    Content,
    Header,
    Heading,
    NonDraggableArea,
    Sheet,
} from '../../mobile/structural/sheet';
import BoardSharingTabs from './MobileSharingTabs';

// Utils
import useSheet from '../../mobile/structural/sheet/hooks/useSheet';

// Types
import { SheetId } from '../structural/sheet/sheetTypes';
import { GeneralWorkspaceProps } from '../../workspace/workspaceTypes';

const MobileSharingSheet = (props: GeneralWorkspaceProps) => {
    const sheetProps = useSheet(SheetId.Sharing);

    return (
        <SheetContainer {...sheetProps} className="MobileSharingSheet" defaultSnapPoint={1}>
            <Sheet>
                <Header>
                    <Heading>Share this board</Heading>
                    <CloseButton />
                </Header>

                <Content>
                    <NonDraggableArea>
                        <BoardSharingTabs {...props} isSheetOpen={sheetProps.isSheetOpen} />
                    </NonDraggableArea>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileSharingSheet;
